import { createFocusTrap } from 'focus-trap';
import { add, listen, qs, qsa, remove } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { on } from '@/glow/events';
import QuickAddProductForm from '@/lib/quick-add-product';

const classes = {
  visible: 'is-visible',
  active: 'active',
  fixed: 'is-fixed',
};

const selectors = {
  closeBtn: '[data-quick-add-modal-close]',
  wash: '.quick-add-modal__wash',
  modalContent: '.quick-add-modal__content',
};

const quickAddModal = node => {
  const focusTrap = createFocusTrap(node, { allowOutsideClick: true });
  const wash = qs(selectors.wash, node.parentNode);
  const modalContent = qs(selectors.modalContent, node);
  let productForm;

  const events = [
    listen([qs(selectors.closeBtn, node), wash], 'click', e => {
      e.preventDefault();
      _close();
    }),
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) _close();
    }),
    on(
      'quick-add:open',
      (state, { productContent, openQuickCart, quantity }) => {
        _renderProductContent(productContent, openQuickCart, quantity);
        _open();
      }
    ),
    on('quick-add:close', () => {
      _close();
    }),
  ];

  const _renderProductContent = (content, openQuickCart, quantity) => {
    let container = document.createElement('div');
    container.innerHTML = content;

    const productElement = qs('[data-quick-add-product]', container);

    if (quantity > 1) {
      const quantityInputs = qsa(
        ['.product-form__input--quantity', '.product__input--quantity'],
        container
      );
      quantityInputs.forEach(input => (input.value = quantity));
    }

    modalContent.appendChild(productElement);
    productForm = QuickAddProductForm(modalContent, openQuickCart);
  };

  const _open = () => {
    // Due to this component being shared between templates we have to
    // animate around it being fixed to the window
    add(node, classes.fixed);

    setTimeout(() => {
      add(node, classes.visible);
      add(node, classes.active);
    }, 50);

    focusTrap.activate();
    disableBodyScroll(node, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.getAttribute('data-scroll-lock-ignore') !== null) {
            return true;
          }
          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true,
    });
  };

  const _close = () => {
    focusTrap.deactivate();
    remove(node, classes.visible);
    remove(node, classes.active);
    enableBodyScroll(node);

    setTimeout(() => {
      remove(node, classes.fixed);
      modalContent.innerHTML = '';
      productForm.unload();
    }, 300);
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
};

export default quickAddModal;
